import React from 'react';
export function HeroSection() {
  return <section className="bg-cream py-10 md:py-16 px-5" data-id="element-220">
      <div className="max-w-4xl mx-auto text-center" data-id="element-221">
        {/* Eyebrow */}
        <p className="font-sans text-sm font-semibold uppercase tracking-widest text-forest mb-6" data-id="element-222">
          For Homeowners Who Actually Care About Their Garden
        </p>

        {/* Main Headline */}
        <h1 className="font-serif text-forest text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-223">
          Discover the System That Is Protecting Gardens All Across America From
          Hard Freezes, Extreme Heat, and Invasive Pests
        </h1>

        {/* Subheadline */}
        <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto mb-10 leading-relaxed font-sans" data-id="element-224">
          The 365 Garden Shield gives you the exact season-by-season protection
          system that saves American homeowners thousands in dead plants every
          year
        </p>

        {/* CTA Button — RED HEARTBEAT */}
        <a href="#solution" className="cta-heartbeat inline-block bg-red-600 hover:bg-red-700 text-white text-lg font-bold py-4 px-10 rounded-lg shadow-lg transition-colors duration-200 mb-4" data-id="element-225">
          YES! PROTECT MY GARDEN NOW — $6.37
        </a>

        {/* Trust line */}
        <p className="text-sm text-gray-500 font-sans mb-12" data-id="element-226">
          🔒 Instant Access &nbsp;|&nbsp; ✅ 7-Day Money Back Guarantee
        </p>
      </div>
    </section>;
}